import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link, Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import classNames from 'classnames';
import { closest } from 'fastest-levenshtein';
import i18n from 'cityads-v3/i18n';

import MediaQuery from 'react-responsive';
import MenuItem from '@material-ui/core/MenuItem';
import Emoji from 'cityads-v3/components/Emoji/Emoji'
import MenuPopper from 'cityads-v3/components/MenuPopper/MenuPopper';
import TemporaryRedirect from 'cityads-v3/components/Router/TemporaryRedirect';
import Typography from '@material-ui/core/Typography'
import PermanentRedirect from 'cityads-v3/components/Router/PermanentRedirect';

import ForgotDialog from 'cityads-v3/containers/Auth/ForgotDialog';
import LoginDialog from 'cityads-v3/containers/Auth/LoginDialog';
import RegistrationDialog from 'cityads-v3/containers/Auth/RegistrationDialog';
import ResetDialog from 'cityads-v3/containers/Auth/ResetDialog';
import WelcomeDialog from 'cityads-v3/containers/Auth/WelcomeDialog';

import HeaderCredits from './HeaderCredits';
import HeaderEvents from './HeaderEvents';
import HeaderManager from './HeaderManager';
import HeaderTheme from './HeaderTheme'
import HeaderUser from './HeaderUser';

import { setLanguage } from 'cityads-v3/actions/language';

import { authRegexp } from 'cityads-v3/utils/authUtils';
import { breakpoints } from 'cityads-v3/utils/styleUtils';
import classes from './HeaderToolbar.scss';

const serverMediaDefaults = {
  width: breakpoints.md,
};

export const MENU_LINKS = [
  {
    to: '/main/about',
    title: 'header.about',
    icon: 'help_outline'
  },
  {
    to: '/publisher/offers',
    title: 'header.offers',
    icon: 'stars'
  },
  {
    to: '/main/news',
    title: 'header.blog',
    requireLanguage: 'ru',
    icon: 'library_books'
  },
];

const ALLOWED_REGISTRATION_TAB_VALUES = ['publisher', 'advertiser', 'blogger'];

@withRouter
@connect(
  state => ({
    changingLanguageTo: state.language.changingLanguageTo,
    checkingAuth      : state.auth.checkingAuth,
    language          : state.language.language,
    languageList      : state.language.languageList,
    languagesById     : state.language.languagesById,
    isLoggedIn        : state.auth.isLoggedIn,
    user              : state.auth.user,
  })
)
@withTranslation(['main'], { i18n, wait: false })
export default class HeaderToolbar extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,

    i18n: PropTypes.object.isRequired,
    t   : PropTypes.func.isRequired,

    language          : PropTypes.string,
    changingLanguageTo: PropTypes.string,
    languageList      : PropTypes.arrayOf(PropTypes.string),
    languagesById     : PropTypes.objectOf(PropTypes.object),
    checkingAuth      : PropTypes.bool,
    isLoggedIn        : PropTypes.bool,

    user: PropTypes.object,
  }

  state = {
    isLanguageMenuOpen: false,
  }

  clickLanguage(language) {
    const { dispatch, i18n } = this.props;

    this.hideLanguageMenu();

    dispatch(setLanguage({ language, i18n }));
  }

  setLanguageMenuAnchor = (elem) => {
    this.languageAnchor = elem;
  }

  showLanguageMenu = () => {
    this.setState({
      isLanguageMenuOpen: !this.props.changingLanguageTo
    });
  }

  hideLanguageMenu = () => {
    this.setState({
      isLanguageMenuOpen: false
    });
  }

  onAuthTabChange = (tab) => {
    const { location } = this.props;

    this.props.history.replace({
      ...location,
      pathname: location.pathname.replace(authRegexp, (a, type) => `/${type}/${tab}`)
    });
  }

  hideAuthForm = () => {
    this.props.history.push(this.getLocationWithoutAuth());
  }

  getLocationWithoutAuth() {
    const { location } = this.props;

    return {
      ...location,
      pathname: location.pathname.replace(authRegexp, '')
    };
  }

  renderLinks(dropdown = false) {
    const { language, isLoggedIn, t, user } = this.props;

    return MENU_LINKS
      .filter(({ requireLanguage, requireLoggedIn, requireLoggedRole }) => {

        if (requireLanguage && requireLanguage !== language) {
          return false;
        }

        if (requireLoggedIn) {
          if (!isLoggedIn) {
            return false;
          }

          if (requireLoggedRole && requireLoggedRole.indexOf(user && user.user_role_code) === -1) {
            return false;
          }
        }

        return true;
      })
      .map(({ to, href, title }, idx) => (dropdown ?
        (
          <MenuItem key={idx} href={href || undefined} containerElement={to ? <Link to={to} /> : undefined} primaryText={t(title)} />
        ) : (
          href ?
            <Typography component="a" color="textPrimary" key={idx} href={href} className={classNames(classes.item, classes.itemLink)}>{t(title)}</Typography> :
            <Typography component={Link} color="textPrimary" key={idx} className={classNames(classes.item, classes.itemLink)} to={to}>{t(title)}</Typography>
        )
      ))
  }

  render() {
    const { language, changingLanguageTo, languageList, languagesById, location, user, isLoggedIn } = this.props;

    const languageItems = languageList.map(lang => languagesById[lang]).map(language => (
      <MenuItem
        key         = {language.id}
        value       = {language.id}
        onClick     = {(evt) => this.clickLanguage(language.id)}
      >
        {language.flag && <span className={classes.flag}><Emoji icon={true} size={24} code={`:flag_${language.flag}:`} /></span>}
        {language.name}
      </MenuItem>
    ));

    const authLocation = {
      ...location,
      pathname: location.pathname.replace(authRegexp, '') + '/auth'
    };

    const locationWithoutAuth = this.getLocationWithoutAuth();

    return (
      <div className={classes.headerToolbar}>
        <MediaQuery key="start" maxWidth={breakpoints.sm} device={window ? null : serverMediaDefaults}>
          {isMobile => (
            <div className={classes.wideToolbar}>
              {(isLoggedIn || isMobile) ? false : this.renderLinks(false)}

              <HeaderEvents />
              <HeaderManager />
              <HeaderCredits />
              <HeaderUser
                authLocation={authLocation}
              />

              <div className={classNames(classes.item, classes.itemLang)}>
                <Typography
                  component="div"
                  ref={this.setLanguageMenuAnchor}
                  onClick={this.showLanguageMenu}
                  color="textPrimary"
                  variant="caption"
                >
                  {String(changingLanguageTo ?? language).toUpperCase()}
                </Typography>
                <MenuPopper
                  className      = {classes.languagePopover}
                  paperClassName = {classes.languagePopoverContent}
                  open           = {this.state.isLanguageMenuOpen}
                  anchorEl       = {this.languageAnchor}
                  placement      = {'bottom-end'}
                  onClose        = {this.hideLanguageMenu}
                >
                  {languageItems}
                </MenuPopper>
              </div>

              <HeaderTheme />
            </div>
          )}
        </MediaQuery>

        {user ?
          (
            <>
              <Route path="*/auth" render={() => (
                <TemporaryRedirect to={location.pathname.replace(authRegexp, '')} />
              )} />
              <Route path="*/register" render={() => (
                <WelcomeDialog
                  onRequestClose = {this.hideAuthForm}
                  closeLink      = {locationWithoutAuth}
                />
              )} />
            </>
          ) :
          (
            <>
              <Route path="*/auth" render={() => (
                <LoginDialog
                  onRequestClose = {this.hideAuthForm}
                  closeLink      = {locationWithoutAuth}
                />
              )} />
              <Route path="*/register/:tabName?" render={({ match }) => (
                ALLOWED_REGISTRATION_TAB_VALUES.includes(match.params.tabName) ? (
                  <RegistrationDialog
                    onRequestClose = {this.hideAuthForm}
                    closeLink      = {locationWithoutAuth}
                    tab            = {match.params.tabName}
                    onTabChange    = {this.onAuthTabChange}
                  />
                ) : (
                  <PermanentRedirect to={location.pathname.replace(authRegexp, `/register/${closest(match.params.tabName ?? '', ALLOWED_REGISTRATION_TAB_VALUES)}`)} />
                )
              )} />
            </>
          )
        }
        <Route path="*/lost" render={({ location }) => {
          const parsedLocation = queryString.parse(location.search);

          return parsedLocation.key ?
            (
              <ResetDialog
                onRequestClose = {this.hideAuthForm}
                closeLink      = {locationWithoutAuth}
                resetKey       = {parsedLocation.key}
              />
            ) :
            (
              <ForgotDialog
                onRequestClose = {this.hideAuthForm}
                closeLink      = {locationWithoutAuth}
              />
            )
        }} />
      </div>
    );
  }
}
